// src/contexts/caixas/CaixaContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchData } from '../../services/Api.js';
import { Caixa } from '../../models/caixas/Caixa.js';
import { Usuario } from '../../models/geral/Usuario.ts';
import CaixaFechamento from '../../pages/caixas/CaixaFechamento.js';
import { useAlert } from '../geral/AlertContext.js';
import CaixaMovLan from '../../pages/caixas/CaixaMovLan.js';

const CaixaContext = createContext();

export const useCaixa = () => useContext(CaixaContext);

export const CaixaProvider = ({ children }) => {  
    const [caixaSel, setCaixaSel] = useState(new Caixa());
    const [showFechaCaixa, setShowFechaCaixa] = useState(false);
    const [usuarioSel, setUsuarioSel] = useState(new Usuario());
    const [showCaixaMov, setShowCaixaMov] = useState(false); 

    const { showAlert } = useAlert();

    // Efeito para inicialização da tela
    useEffect(() => {
        const fetchCaixa = async () => {
        try {
            const result = await fetchData('/Caixa', { caixaId: 1 });
            setCaixaSel(result);
            const usuarioId = localStorage.getItem('usuarioId');
            const usuarioNome = localStorage.getItem('usuarioNome');
            setUsuarioSel({ id: usuarioId, nome: usuarioNome });
        } catch (error) {
            console.error("Erro ao buscar o status do caixa:", error);
            showAlert('Erro ao buscar o status do caixa', 'danger');
        }
        };
        fetchCaixa();
    }, []);

    
    const fecharCaixa = () => {
        setShowFechaCaixa(true);
    }    

    return (
        <CaixaContext.Provider value={{ caixaSel, setCaixaSel, usuarioSel, fecharCaixa, showCaixaMov, setShowCaixaMov }}>
            {children}
            <CaixaFechamento
                show={showFechaCaixa}
                onHide={() => setShowFechaCaixa(false)}
                caixa={caixaSel}
                setCaixa={setCaixaSel}
                usuario={usuarioSel}
            />
            <CaixaMovLan //ajustes sangria
                show={showCaixaMov}
                onHide={() => setShowCaixaMov(false)}
                caixa={caixaSel}
                setCaixa={setCaixaSel}
                usuario={usuarioSel}
            />         
        </CaixaContext.Provider>
    );
};
